export const blockIconsFileTopic = (
	<span className='material-symbols-outlined'>topic</span>
);
